import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogs } from "../logs/LogsContext";

export default function ErrorDetailsAccordion({
  details,
  title = "Error details",
  compact = false,
}) {
  const [open, setOpen] = useState(false);
  const logs = useLogs();
  const navigate = useNavigate();

  if (!details) return null;

  const detailsJson =
    typeof details === "string" ? details : JSON.stringify(details, null, 2);

  function handleSendToLogs() {
    let entryId = null;
    try {
      entryId = logs.log("error", title, details);
    } catch (err) {
      // ignore logging failure
    }
    // show a small toast so user has immediate feedback (DOM-based so it survives
    // a route navigation), then navigate to system logs so user can view the entry
    try {
      showToast("Sent to Logs");
    } catch {}
    if (entryId) {
      navigate("/system-logs", { state: { highlightId: entryId } });
    } else {
      navigate("/system-logs");
    }
  }

  function showToast(message, duration = 2200) {
    if (typeof document === "undefined") return;
    const el = document.createElement("div");
    el.textContent = message;
    Object.assign(el.style, {
      position: "fixed",
      right: "20px",
      bottom: "24px",
      background: "rgba(17,17,17,0.95)",
      color: "#fff",
      padding: "8px 12px",
      borderRadius: "8px",
      boxShadow: "0 6px 18px rgba(0,0,0,0.16)",
      zIndex: 99999,
      opacity: "0",
      transform: "translateY(8px)",
      transition: "opacity 180ms ease, transform 180ms ease",
      fontSize: "13px",
      fontFamily:
        "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
    });
    document.body.appendChild(el);
    // trigger transition
    requestAnimationFrame(() => {
      el.style.opacity = "1";
      el.style.transform = "translateY(0)";
    });
    setTimeout(() => {
      el.style.opacity = "0";
      el.style.transform = "translateY(8px)";
      setTimeout(() => {
        try {
          el.remove();
        } catch (err) {}
      }, 200);
    }, duration);
  }

  return (
    <div style={{ marginTop: 8 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <button
          className="link-btn"
          onClick={() => setOpen((s) => !s)}
          aria-expanded={open}
        >
          {open ? "Hide details" : "Show details"}
        </button>
        <button className="link-btn" onClick={handleSendToLogs}>
          Send to Logs
        </button>
      </div>

      {open && (
        <pre
          style={{
            marginTop: 8,
            padding: 12,
            background: "#fafafa",
            border: "1px solid #eee",
            borderRadius: 8,
            overflow: "auto",
            maxHeight: 300,
            fontSize: 12,
            whiteSpace: "pre-wrap",
          }}
        >
          {detailsJson}
        </pre>
      )}
    </div>
  );
}
